import { Suspense } from 'react';
import { lazyWithReload } from './helpers/lazyWithReload';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Slide, ToastContainer } from 'react-toastify';
import { CrossIcon } from './helpers/icons';
import { FullPageLoader } from './components';
import './styles/styles.scss';
import 'react-toastify/dist/ReactToastify.css';
import 'react-phone-number-input/style.css';
import 'react-datepicker/dist/react-datepicker.css';
// import 'jodit/build/jodit.min.css';
import 'swiper/css'; // Import core Swiper styles
import 'swiper/css/navigation'; // Import navigation styles
import { pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = `/pdf.worker.min.js`;

const App = lazyWithReload(() => import('./App'));

const root = ReactDOM.createRoot(document.getElementById('root'));

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

root.render(
  <Suspense fallback={<FullPageLoader />}>
    <QueryClientProvider client={queryClient}>
      <App />
      <ToastContainer
        limit={6}
        draggable="mouse"
        pauseOnHover
        role="alert"
        closeButton={CrossIcon}
        position="bottom-left"
        transition={Slide}
        draggablePercent={50}
        newestOnTop
        autoClose={1500}
      />
    </QueryClientProvider>
  </Suspense>,
);
